import type { Rect } from './geometry';
import type { Position } from './position';

export type HandleType = 'source' | 'target';

/** A measured handle: its box relative to the node's top-left corner, in flow units. */
export type HandleBound = Rect & {
  id: string | null;
  type: HandleType;
  position: Position;
};

/** All measured handles of one node, split by type (v11 `handleBounds`). */
export type HandleBounds = { source: HandleBound[]; target: HandleBound[] };

/** Which handles a connection may end on. Values match React Flow v11. */
export enum ConnectionMode {
  Strict = 'strict',
  Loose = 'loose',
}
